import { useLocation } from "react-router-dom";
import NavBar from "../../components/NavBar";
import { Outlet } from "react-router-dom";
import SearchBarProvider from "../../components/SearchBarProvider";
import SearchBar from "../../components/SearchBar";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { logoutRequest } from "../../api/api";
import axios, { AxiosError } from "axios";

export default function Layout({ onLogout }: { onLogout: () => void }) {
  const location = useLocation();
  const queryClient = useQueryClient();

  const handleLogout = useMutation({
    mutationFn: logoutRequest,
    onSuccess: (data) => {
      if (data.success) {
        queryClient.invalidateQueries();
        onLogout();
      }
    },
    onError: (error) => {
      if (axios.isAxiosError(error)) {
        const axiosError = error as AxiosError<any>;
        if (axiosError.response) {
          const responseData = axiosError.response.data;
          console.log(responseData);
        }
      }
    },
  });

  return (
    <div className="flex flex-col items-center xl:items-start h-screen">
      <NavBar
        logout={() => {
          handleLogout.mutate();
        }}
      />
      <div className="static pt-24 pb-4 xl:pb-8 xl:pt-8 xl:pl-36 px-4 xl:px-16 w-full self-center">
        <SearchBarProvider>
          {(location.pathname === "/series" ||
            location.pathname === "/movies" ||
            location.pathname === "/bookmarks" ||
            location.pathname === "/") && <SearchBar />}
          <Outlet />
        </SearchBarProvider>
      </div>
    </div>
  );
}
